import { STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT } from "../../Stages/StagesCase";
import { previewFeedbackMessageButton } from "./litigationCaseDetailsSpecialActions";
import { GeneralCivilLaw } from "../../../types/Products/GeneralCivilLaw";

export const generalCivilLawDetailsSpecialActions = (product: GeneralCivilLaw) => {
  let specialActions = [];

  if (product.stage === STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT) {
    specialActions.push(previewFeedbackMessageButton(product));
  }

  if (specialActions.length === 0) {
    return null;
  }

  return specialActions;
};
